import React from 'react'
import { MapHelperPropsType } from './types'

// Styles
import './styles.scss'

// Icons
import IconDefaultLesson from './images/iconDefaultLesson'
import IconCompleteLesson from './images/iconCompleteLesson'
import IconBlockedLesson from './images/iconBlockedLesson'
import IconTimeLesson from './images/iconTimeLesson'

export default ({ style }: MapHelperPropsType) => {
  const lessonTypes = [
    { icon: <IconDefaultLesson />, title: 'Доступный урок' },
    { icon: <IconCompleteLesson />, title: 'Выполненный урок' },
    { icon: <IconBlockedLesson />, title: 'Недоступный урок' },
    { icon: <IconTimeLesson />, title: 'Урок, который скоро откроется' },
  ]

  return (
    <div className={'map-helper'} style={style}>
      {lessonTypes.map((type, index) => (
        <div key={`lesson-type-${index}`} className={'map-helper__item'}>
          {type.icon}
          <span>{type.title}</span>
        </div>
      ))}
    </div>
  )
}
